import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "control__box" }
const _hoisted_2 = ["title", "aria-label", "disabled"]
const _hoisted_3 = { class: "control__icon-box" }
const _hoisted_4 = { class: "control__icon-box" }

import { onMounted } from 'vue'

import type { DocView } from '@/models/doc'
import { emitter } from '@/services/mitt'
import SidebarFavorite from '@/app/components/doc/reading/SidebarFavorite.vue'
import DocMoreMenu from '@/app/components/doc/DocMoreMenu.vue'
import SaveButton from '@/app/components/doc/SaveButton.vue'
import SidebarSettings from '@/app/components/doc/reading/SidebarSettings.vue'
import { DESKTOP_WIDTH } from '@/init/settings'
import { Mixpanel } from '@/analytics/mixpanel'
import { saveForLater20321Treatment } from '@/services/ab/experiments'


export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    doc: {},
    showTextControls: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const showNewSaveDesign = saveForLater20321Treatment()

onMounted(async () => {
  // The 'docContentClicked' is emitted in @/app/components/doc/reading/Content.vue and
  // @/app/components/article/Content.vue
  emitter.on('docContentClicked', (event: any) => {
    props.doc.controls.onDocContentClicked(event)
  })
  emitter.on('showBookControlBar', () => {
    props.doc.controls.show()
  })
  emitter.on('windowResize', () => {
    props.doc.controls.onWindowResize()
  })
  emitter.on('toggleNightMode', async () => {
    props.doc.controls.onToggleNightMode()
  })
  // The 'docContentSelectionStarted' is emitted in @/app/components/doc/reading/Annotator.vue
  emitter.on('docContentSelectionStarted', () => {
    // Don't hide controls on desktop screens
    if (window.innerWidth >= DESKTOP_WIDTH) {
      return
    }

    props.doc.controls.hide()
  })
})

function togglePlayer(event: Event): void {
  props.doc.controls.togglePlayer(event)
  Mixpanel.trackSidebarItemClick('Player')
}

async function toggleNightMode(): Promise<void> {
  await props.doc.controls.toggleNightMode()
  Mixpanel.trackSidebarItemClick('Night Mode')
}

return (_ctx: any,_cache: any) => {
  return (__props.doc)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([__props.doc.controls.bookSidebarClass, "control"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (__props.showTextControls)
            ? (_openBlock(), _createBlock(SidebarSettings, {
                key: 0,
                class: _normalizeClass(__props.doc.controls.fontsBtnClass),
                doc: __props.doc
              }, null, 8, ["class", "doc"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default"),
          (__props.showTextControls && __props.doc.has_audio)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([__props.doc.controls.playerBtnClass, "control__btn player-btn"]),
                title: "Listen",
                onClick: togglePlayer
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "control__icon-box" }, [
                  _createElementVNode("span", { class: "control__icon iconfont icontrol-listen" })
                ], -1)
              ]))], 2))
            : _createCommentVNode("", true),
          (_unref(showNewSaveDesign))
            ? (_openBlock(), _createBlock(SaveButton, {
                key: 2,
                doc: __props.doc
              }, {
                default: _withCtx(({ isSaved, isBusy, icon, label }) => [
                  _createElementVNode("button", {
                    class: _normalizeClass(["control__btn save-btn", __props.doc.controls.favoriteBtnClass]),
                    title: label,
                    "aria-label": label,
                    disabled: isBusy
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["control__icon iconfont", [icon, { 'control__icon--saved': isSaved }]])
                      }, null, 2)
                    ])
                  ], 10, _hoisted_2)
                ]),
                _: 1
              }, 8, ["doc"]))
            : (_openBlock(), _createBlock(SidebarFavorite, {
                key: 3,
                doc: __props.doc,
                class: _normalizeClass(__props.doc.controls.favoriteBtnClass)
              }, null, 8, ["doc", "class"])),
          _createElementVNode("div", {
            class: _normalizeClass([__props.doc.controls.nightModeBtnClass, "control__btn night-btn"]),
            title: "Night mode",
            onClick: toggleNightMode
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: _normalizeClass(__props.doc.controls.nightModeIconClass)
              }, null, 2)
            ])
          ], 2),
          (_unref(showNewSaveDesign))
            ? (_openBlock(), _createBlock(DocMoreMenu, {
                key: 4,
                class: "control__more-menu",
                doc: __props.doc
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("button", {
                    class: "control__btn more-btn",
                    title: "More actions",
                    "aria-label": "More actions"
                  }, [
                    _createElementVNode("div", { class: "control__icon-box" }, [
                      _createElementVNode("span", { class: "control__icon iconfont imore" })
                    ])
                  ], -1)
                ]))]),
                _: 1
              }, 8, ["doc"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "tutorial")
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})